import { format } from "date-fns-tz";

/**
 * Returns an ISO8601 string using the offset of a specific timezone.
 *
 * This can be nescessary as the 'Date' objects built in '.toIsoString()'
 * method will always return a date as a UTC string.
 */
export function toZonedISOString(date: Date, timezone: string) {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX", { timeZone: timezone });
}
